var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 18.3334C3.33398 12.8337 3.33398 10.0838 5.04253 8.3753C6.75107 6.66675 9.50093 6.66675 15.0007 6.66675H16.6673C22.167 6.66675 24.9168 6.66675 26.6255 8.3753C28.334 10.0838 28.334 12.8337 28.334 18.3334V21.6667C28.334 27.1664 28.334 29.9162 26.6255 31.6249C24.9168 33.3334 22.167 33.3334 16.6673 33.3334H15.0007C9.50093 33.3334 6.75107 33.3334 5.04253 31.6249C3.33398 29.9162 3.33398 27.1664 3.33398 21.6667V18.3334Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.334 14.843L28.5438 14.6699C32.0702 11.7603 33.8333 10.3055 35.2503 11.008C36.6673 11.7104 36.6673 14.0392 36.6673 18.6968V21.3031C36.6673 25.9608 36.6673 28.2894 35.2503 28.9919C33.8333 29.6943 32.0702 28.2396 28.5438 25.3299L28.334 25.1568",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.334 14.843L28.5438 14.6699C32.0702 11.7603 33.8333 10.3055 35.2503 11.008C36.6673 11.7104 36.6673 14.0392 36.6673 18.6968V21.3031C36.6673 25.9608 36.6673 28.2894 35.2503 28.9919C33.8333 29.6943 32.0702 28.2396 28.5438 25.3299L28.334 25.1568",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.166 18.3333C20.5467 18.3333 21.666 17.214 21.666 15.8333C21.666 14.4525 20.5467 13.3333 19.166 13.3333C17.7853 13.3333 16.666 14.4525 16.666 15.8333C16.666 17.214 17.7853 18.3333 19.166 18.3333Z",
    fill: "#012E89",
    stroke: "#012E89",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo01);
export default __webpack_public_path__ + "static/media/video-01.62f755df41962111a2bcb3e82faa29e5.svg";
export { ForwardRef as ReactComponent };